<template>
  <v-textarea
    autocomplete="off"
    :label="label"
    :required="required"
    :name="name"
    :prepend-inner-icon="iconLeft"
    :append-icon="iconRight"
    :outlined="outlined"
    :loading="loading"
    :rules="getRules"
    :error="getError"
    :error-messages="getErrorContents"
    :value="value"
    :disabled="disabled"
    :readonly="readonly"
    :color="color"
    :placeholder="placeholder"
    :rows="rows"
    :persistent-hint="info ? true : false"
    validate-on-blur
    @input="$emit('input', $event)"
    @keydown="$emit('keydown', $event)"
    @blur="$emit('blur', $event)"
    @keyup.enter="$emit('keyup', $event)"
    @change="$emit('change', $event)"
    auto-grow
  >
    <template v-slot:prepend v-if="!!$slots.prepend">
      <slot name="prepend" />
    </template>

    <template v-slot:append v-if="!!$slots.append || info">
      <i :class="$utilidade.getIcone('info')" :title="info" v-if="info" />
      <slot name="append" />
    </template>
  </v-textarea>
</template>

<script>
import EdFormMixin from "./mixins/formControl";

export default {
  name: "EdInputTextArea",
  mixins: [EdFormMixin],
  props: {
    rows: {
      type: [Number, String],
      required: false,
      default: "3",
    },
  },
  data() {
    return {};
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/components/template/EdInputTextArea.vue